/* global axios */
import ApiClient from './ApiClient';

// Generic document-request checklist API for any owner resource that includes the
// DocumentRequestable concern (e.g. 'projects', 'tickets'). The owner id is the
// resource's URL id — for tickets that is the ticket display_id.
class DocumentRequestsAPI extends ApiClient {
  constructor(ownerResource) {
    super('document_requests', { accountScoped: true });
    this.ownerResource = ownerResource;
    this.ownerId = null;
  }

  get url() {
    return `${this.baseUrl()}/${this.ownerResource}/${this.ownerId}/document_requests`;
  }

  get(ownerId) {
    this.ownerId = ownerId;
    return super.get();
  }

  create(ownerId, data) {
    this.ownerId = ownerId;
    return super.create({ document_request: data });
  }

  update(ownerId, id, data) {
    this.ownerId = ownerId;
    return super.update(id, { document_request: data });
  }

  delete(ownerId, id) {
    this.ownerId = ownerId;
    return super.delete(id);
  }

  reorder(ownerId, ids) {
    this.ownerId = ownerId;
    return axios.post(`${this.url}/reorder`, { ids });
  }

  accept(ownerId, id) {
    this.ownerId = ownerId;
    return axios.post(`${this.url}/${id}/accept`);
  }

  reject(ownerId, id, reviewNote) {
    this.ownerId = ownerId;
    return axios.post(`${this.url}/${id}/reject`, { review_note: reviewNote });
  }
}

export default DocumentRequestsAPI;
